import {
  ChakraBox,
  ChakraFlex,
  ChakraVStack,
  EquipUIFireflyV2Theme,
  FAIconName,
  Icon,
  Text,
} from '@equip.health/ui';

import Authorizations from '~/components/common/billingPeriods/BillingPeriodAuthorizationsList';
import BillingPeriodDetails from '~/components/common/billingPeriods/BillingPeriodDetails';
import BillingPeriodLayout from '~/components/common/billingPeriods/BillingPeriodLayout';
import { BillingPeriodProps } from '~/components/common/billingPeriods/types';
import { BILLING_PERIODS_TOP_LEVEL_ID } from '~/lib/constants';
import { getBillingPeriodCoverageInfo } from '~/lib/util/billingPeriod.util';

const {
  critical: { base: criticalBase },
} = EquipUIFireflyV2Theme.colors;

const BillingPeriodCreate = ({ billingPeriodState }: BillingPeriodProps) => {
  const {
    updatedBillingPeriod,
    isSaveBillingPeriodError,
    updateBillingPeriodState,
  } = billingPeriodState;
  const billingPeriodDetails =
    getBillingPeriodCoverageInfo(updatedBillingPeriod);

  return (
    <ChakraBox
      id={`${BILLING_PERIODS_TOP_LEVEL_ID}__create`}
      overflow="hidden"
      padding="20px"
    >
      <ChakraVStack alignItems="flex-start" gap="24px">
        <BillingPeriodLayout isHeaderVisible title="Billing period">
          <BillingPeriodDetails
            billingPeriodDetails={billingPeriodDetails}
            showRequiredFieldErrors={false}
            updateBillingPeriodState={updateBillingPeriodState}
          />
        </BillingPeriodLayout>
        <Authorizations
          authorizations={updatedBillingPeriod?.authorizationDetails}
          billingPeriodState={billingPeriodState}
          isAuthorizationRequired={updatedBillingPeriod?.isAuthRequired}
          showRequiredFieldErrors={false}
        />
        {isSaveBillingPeriodError && (
          <ChakraFlex
            alignItems="center"
            background="critical.background"
            borderRadius="12px"
            gap="12px"
            padding="12px 20px"
            width="100%"
          >
            <Icon
              color={criticalBase}
              name={FAIconName.exclamationTriangleRegular}
            />
            <Text>
              We’re sorry, we were unable to save your changes at this time.
              Please try again.
            </Text>
          </ChakraFlex>
        )}
      </ChakraVStack>
    </ChakraBox>
  );
};

export default BillingPeriodCreate;
